/* */ 
"use strict";
var __extends = (this && this.__extends) || function(d, b) {
  for (var p in b)
    if (b.hasOwnProperty(p))
      d[p] = b[p];
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var collection_1 = require('../facade/collection');
var element_1 = require('./element');
var lang_1 = require('../facade/lang');
var async_1 = require('../facade/async');
var view_ref_1 = require('./view_ref');
var view_type_1 = require('./view_type');
var view_utils_1 = require('./view_utils');
var change_detection_1 = require('../change_detection/change_detection');
var profile_1 = require('../profile/profile');
var exceptions_1 = require('./exceptions');
var debug_context_1 = require('./debug_context');
var element_injector_1 = require('./element_injector');
var _scope_check = profile_1.wtfCreateScope("AppView#check(ascii id)");
var AppView = (function() {
  function AppView(clazz, componentType, type, viewUtils, parentInjector, declarationAppElement, cdMode) {
    this.clazz = clazz;
    this.componentType = componentType;
    this.type = type;
    this.viewUtils = viewUtils;
    this.parentInjector = parentInjector;
    this.declarationAppElement = declarationAppElement;
    this.cdMode = cdMode;
    this.contentChildren = [];
    this.viewChildren = [];
    this.viewContainerElement = null;
    this.cdState = change_detection_1.ChangeDetectorState.NeverChecked;
    this.destroyed = false;
    this.ref = new view_ref_1.ViewRef_(this);
    if (type === view_type_1.ViewType.COMPONENT || type === view_type_1.ViewType.HOST) {
      this.renderer = viewUtils.renderComponent(componentType);
    } else {
      this.renderer = declarationAppElement.parentView.renderer;
    }
  }
  AppView.prototype.create = function(context, givenProjectableNodes, rootSelectorOrNode) {
    this.context = context;
    var projectableNodes;
    switch (this.type) {
      case view_type_1.ViewType.COMPONENT:
        projectableNodes = view_utils_1.ensureSlotCount(givenProjectableNodes, this.componentType.slotCount);
        break;
      case view_type_1.ViewType.EMBEDDED:
        projectableNodes = this.declarationAppElement.parentView.projectableNodes;
        break;
      case view_type_1.ViewType.HOST:
        projectableNodes = givenProjectableNodes;
        break;
    }
    this._hasExternalHostElement = lang_1.isPresent(rootSelectorOrNode);
    this.projectableNodes = projectableNodes;
    return this.createInternal(rootSelectorOrNode);
  };
  AppView.prototype.createInternal = function(rootSelectorOrNode) {
    return null;
  };
  AppView.prototype.init = function(rootNodesOrAppElements, allNodes, disposables, subscriptions) {
    this.rootNodesOrAppElements = rootNodesOrAppElements;
    this.allNodes = allNodes;
    this.disposables = disposables;
    this.subscriptions = subscriptions;
    if (this.type === view_type_1.ViewType.COMPONENT) {
      this.declarationAppElement.parentView.viewChildren.push(this);
      this.dirtyParentQueriesInternal();
    }
  };
  AppView.prototype.selectOrCreateHostElement = function(elementName, rootSelectorOrNode, debugInfo) {
    var hostElement;
    if (lang_1.isPresent(rootSelectorOrNode)) {
      hostElement = this.renderer.selectRootElement(rootSelectorOrNode, debugInfo);
    } else {
      hostElement = this.renderer.createElement(null, elementName, debugInfo);
    }
    return hostElement;
  };
  AppView.prototype.injectorGet = function(token, nodeIndex, notFoundResult) {
    return this.injectorGetInternal(token, nodeIndex, notFoundResult);
  };
  AppView.prototype.injectorGetInternal = function(token, nodeIndex, notFoundResult) {
    return notFoundResult;
  };
  AppView.prototype.injector = function(nodeIndex) {
    if (lang_1.isPresent(nodeIndex)) {
      return new element_injector_1.ElementInjector(this, nodeIndex);
    } else {
      return this.parentInjector;
    }
  };
  AppView.prototype.destroy = function() {
    if (this._hasExternalHostElement) {
      this.renderer.detachView(this.flatRootNodes);
    } else if (lang_1.isPresent(this.viewContainerElement)) {
      this.viewContainerElement.detachView(this.viewContainerElement.nestedViews.indexOf(this));
    }
    this._destroyRecurse();
  };
  AppView.prototype._destroyRecurse = function() {
    if (this.destroyed) {
      return;
    }
    var children = this.contentChildren;
    for (var i = 0; i < children.length; i++) {
      children[i]._destroyRecurse();
    }
    children = this.viewChildren;
    for (var i = 0; i < children.length; i++) {
      children[i]._destroyRecurse();
    }
    this.destroyLocal();
    this.destroyed = true;
  };
  AppView.prototype.destroyLocal = function() {
    var hostElement = this.type === view_type_1.ViewType.COMPONENT ? this.declarationAppElement.nativeElement : null;
    for (var i = 0; i < this.disposables.length; i++) {
      this.disposables[i]();
    }
    for (var i = 0; i < this.subscriptions.length; i++) {
      async_1.ObservableWrapper.dispose(this.subscriptions[i]);
    }
    this.destroyInternal();
    if (this._hasExternalHostElement) {
      this.renderer.detachView(this.flatRootNodes);
    } else if (lang_1.isPresent(this.viewContainerElement)) {
      this.viewContainerElement.detachView(this.viewContainerElement.nestedViews.indexOf(this));
    } else {
      this.dirtyParentQueriesInternal();
    }
    this.renderer.destroyView(hostElement, this.allNodes);
  };
  AppView.prototype.destroyInternal = function() {};
  Object.defineProperty(AppView.prototype, "changeDetectorRef", {
    get: function() {
      return this.ref;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(AppView.prototype, "parent", {
    get: function() {
      return lang_1.isPresent(this.declarationAppElement) ? this.declarationAppElement.parentView : null;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(AppView.prototype, "flatRootNodes", {
    get: function() {
      return view_utils_1.flattenNestedViewRenderNodes(this.rootNodesOrAppElements);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(AppView.prototype, "lastRootNode", {
    get: function() {
      var lastNode = this.rootNodesOrAppElements.length > 0 ? this.rootNodesOrAppElements[this.rootNodesOrAppElements.length - 1] : null;
      return _findLastRenderNode(lastNode);
    },
    enumerable: true,
    configurable: true
  });
  AppView.prototype.dirtyParentQueriesInternal = function() {};
  AppView.prototype.detectChanges = function(throwOnChange) {
    var s = _scope_check(this.clazz);
    if (this.cdMode === change_detection_1.ChangeDetectionStrategy.Detached || this.cdMode === change_detection_1.ChangeDetectionStrategy.Checked || this.cdState === change_detection_1.ChangeDetectorState.Errored)
      return;
    if (this.destroyed) {
      this.throwDestroyedError('detectChanges');
    }
    this.detectChangesInternal(throwOnChange);
    if (this.cdMode === change_detection_1.ChangeDetectionStrategy.CheckOnce)
      this.cdMode = change_detection_1.ChangeDetectionStrategy.Checked;
    this.cdState = change_detection_1.ChangeDetectorState.CheckedBefore;
    profile_1.wtfLeave(s);
  };
  AppView.prototype.detectChangesInternal = function(throwOnChange) {
    this.detectContentChildrenChanges(throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  };
  AppView.prototype.detectContentChildrenChanges = function(throwOnChange) {
    for (var i = 0; i < this.contentChildren.length; ++i) {
      this.contentChildren[i].detectChanges(throwOnChange);
    }
  };
  AppView.prototype.detectViewChildrenChanges = function(throwOnChange) {
    for (var i = 0; i < this.viewChildren.length; ++i) {
      this.viewChildren[i].detectChanges(throwOnChange);
    }
  };
  AppView.prototype.addToContentChildren = function(renderAppElement) {
    renderAppElement.parentView.contentChildren.push(this);
    this.viewContainerElement = renderAppElement;
    this.dirtyParentQueriesInternal();
  };
  AppView.prototype.removeFromContentChildren = function(renderAppElement) {
    collection_1.ListWrapper.remove(renderAppElement.parentView.contentChildren, this);
    this.dirtyParentQueriesInternal();
    this.viewContainerElement = null;
  };
  AppView.prototype.markAsCheckOnce = function() {
    this.cdMode = change_detection_1.ChangeDetectionStrategy.CheckOnce;
  };
  AppView.prototype.markPathToRootAsCheckOnce = function() {
    var c = this;
    while (lang_1.isPresent(c) && c.cdMode !== change_detection_1.ChangeDetectionStrategy.Detached) {
      if (c.cdMode === change_detection_1.ChangeDetectionStrategy.Checked) {
        c.cdMode = change_detection_1.ChangeDetectionStrategy.CheckOnce;
      }
      var parentEl = c.type === view_type_1.ViewType.COMPONENT ? c.declarationAppElement : c.viewContainerElement;
      c = lang_1.isPresent(parentEl) ? parentEl.parentView : null;
    }
  };
  AppView.prototype.eventHandler = function(cb) {
    return cb;
  };
  AppView.prototype.throwDestroyedError = function(details) {
    throw new exceptions_1.ViewDestroyedException(details);
  };
  return AppView;
}());
exports.AppView = AppView;
var DebugAppView = (function(_super) {
  __extends(DebugAppView, _super);
  function DebugAppView(clazz, componentType, type, viewUtils, parentInjector, declarationAppElement, cdMode, staticNodeDebugInfos) {
    _super.call(this, clazz, componentType, type, viewUtils, parentInjector, declarationAppElement, cdMode);
    this.staticNodeDebugInfos = staticNodeDebugInfos;
    this._currentDebugContext = null;
  }
  DebugAppView.prototype.create = function(context, givenProjectableNodes, rootSelectorOrNode) {
    this._resetDebug();
    try {
      return _super.prototype.create.call(this, context, givenProjectableNodes, rootSelectorOrNode);
    } catch (e) {
      this._rethrowWithContext(e, e.stack);
      throw e;
    }
  };
  DebugAppView.prototype.injectorGet = function(token, nodeIndex, notFoundResult) {
    this._resetDebug();
    try {
      return _super.prototype.injectorGet.call(this, token, nodeIndex, notFoundResult);
    } catch (e) {
      this._rethrowWithContext(e, e.stack);
      throw e;
    }
  };
  DebugAppView.prototype.destroyLocal = function() {
    this._resetDebug();
    try {
      _super.prototype.destroyLocal.call(this);
    } catch (e) {
      this._rethrowWithContext(e, e.stack);
      throw e;
    }
  };
  DebugAppView.prototype.detectChanges = function(throwOnChange) {
    this._resetDebug();
    try {
      _super.prototype.detectChanges.call(this, throwOnChange);
    } catch (e) {
      this._rethrowWithContext(e, e.stack);
      throw e;
    }
  };
  DebugAppView.prototype._resetDebug = function() {
    this._currentDebugContext = null;
  };
  DebugAppView.prototype.debug = function(nodeIndex, rowNum, colNum) {
    return this._currentDebugContext = new debug_context_1.DebugContext(this, nodeIndex, rowNum, colNum);
  };
  DebugAppView.prototype._rethrowWithContext = function(e, stack) {
    if (!(e instanceof exceptions_1.ViewWrappedException)) {
      if (!(e instanceof exceptions_1.ExpressionChangedAfterItHasBeenCheckedException)) {
        this.cdState = change_detection_1.ChangeDetectorState.Errored;
      }
      if (lang_1.isPresent(this._currentDebugContext)) {
        throw new exceptions_1.ViewWrappedException(e, stack, this._currentDebugContext);
      }
    }
  };
  DebugAppView.prototype.eventHandler = function(cb) {
    var _this = this;
    var superHandler = _super.prototype.eventHandler.call(this, cb);
    return function(event) {
      _this._resetDebug();
      try {
        return superHandler(event);
      } catch (e) {
        _this._rethrowWithContext(e, e.stack);
        throw e;
      }
    };
  };
  return DebugAppView;
}(AppView));
exports.DebugAppView = DebugAppView;
function _findLastRenderNode(node) {
  var lastNode;
  if (node instanceof element_1.AppElement) {
    var appEl = node;
    lastNode = appEl.nativeElement;
    if (lang_1.isPresent(appEl.nestedViews)) {
      for (var i = appEl.nestedViews.length - 1; i >= 0; i--) {
        var nestedView = appEl.nestedViews[i];
        if (nestedView.rootNodesOrAppElements.length > 0) {
          lastNode = _findLastRenderNode(nestedView.rootNodesOrAppElements[nestedView.rootNodesOrAppElements.length - 1]);
        }
      }
    }
  } else {
    lastNode = node;
  }
  return lastNode;
}
